// Shared Plotly styling for the refreshed pages, so charts sit on the panel surface
// the same way everywhere. Functions read window size at call time.
export const CHART = {
        font: "Barlow, 'Helvetica Neue', Arial, sans-serif",
        text: "#c9c9cf",
        muted: "#8d8d96",
        grid: "rgba(255, 255, 255, 0.06)",
        axis: "rgba(255, 255, 255, 0.14)",
        blue: "#2f6fe4",
        yellow: "#f1c40f",
};

export const chartBase = () => ({
        paper_bgcolor: "rgba(0,0,0,0)",
        plot_bgcolor: "rgba(0,0,0,0)",
        font: { family: CHART.font, size: window.innerWidth < 800 ? 10 : 12, color: CHART.text },
        hoverlabel: { bgcolor: "#2a2a2f", bordercolor: "#2a2a2f", font: { family: CHART.font, color: "#ececee" } },
});

export const chartAxis = () => ({
        color: CHART.muted,
        gridcolor: CHART.grid,
        linecolor: CHART.axis,
        zerolinecolor: CHART.axis,
        tickfont: { color: CHART.muted, size: window.innerWidth < 800 ? 10 : 12 },
});

export const chartLegend = (position) => ({
        ...position,
        orientation: window.innerWidth < 900 ? "h" : "v",
        bgcolor: "rgba(27, 27, 30, 0.88)",
        bordercolor: "rgba(255, 255, 255, 0.08)",
        borderwidth: 1,
        font: { size: window.innerWidth < 480 ? 9 : window.innerWidth < 1200 ? 10 : 12, color: CHART.text },
});

// Width for a chart that fills a panel on the wide data pages (72rem column).
// clientWidth excludes the scrollbar, matching the CSS column width.
export const panelChartWidth = (max = 1118) => {
        const viewport = typeof document !== "undefined" ? document.documentElement.clientWidth : window.innerWidth;
        return viewport > 800 ? Math.min(viewport - 60, max) : viewport - 50;
};

// "iracingdata.com" watermark, drawn as a Plotly annotation so it is part of the chart itself
// (it survives screenshots and image exports, and tracks the plot area as charts resize).
// Pick the corner the data leaves empty. With outside: true a top corner sits in the top
// margin, just above the plot area, for charts whose data can reach every corner.
// Pass y to start from another paper height (e.g. a legend's y, then yshift by the legend height).
const WATERMARK_CORNERS = {
        "top-left": { x: 0, y: 1, xanchor: "left", yanchor: "top", xshift: 6, yshift: -4 },
        "top-right": { x: 1, y: 1, xanchor: "right", yanchor: "top", xshift: -6, yshift: -4 },
        "bottom-left": { x: 0, y: 0, xanchor: "left", yanchor: "bottom", xshift: 6, yshift: 4 },
        "bottom-right": { x: 1, y: 0, xanchor: "right", yanchor: "bottom", xshift: -6, yshift: 4 },
};

export const chartWatermark = (corner = "bottom-right", { outside = false, y, xshift = 0, yshift = 0 } = {}) => {
        const pos = WATERMARK_CORNERS[corner] || WATERMARK_CORNERS["bottom-right"];
        const above = outside && pos.y === 1;
        return {
                text: "iracingdata.com",
                xref: "paper",
                yref: "paper",
                x: pos.x,
                y: y ?? pos.y,
                xanchor: pos.xanchor,
                yanchor: above ? "bottom" : pos.yanchor,
                xshift: (above ? 0 : pos.xshift) + xshift,
                yshift: (above ? 2 : pos.yshift) + yshift,
                showarrow: false,
                captureevents: false,
                font: { family: CHART.font, size: window.innerWidth < 800 ? 10 : 15, color: "rgba(255, 255, 255, 0.28)" },
        };
};
